import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/warning-triangle.svg'


const _withScopeId = n => (_pushScopeId("data-v-d79f3b2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "warning_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["Dialog"], {
      visible: $props.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ($setup.emit('closeModal'))),
      modal: "",
      header: "Warning",
      baseZIndex: -100,
      style: { width: '700px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(" When using this payment option, remember that tokens must be sent from the "),
            _createElementVNode("b", null, _toDisplayString($setup.sourceAddress), 1 /* TEXT */),
            _createTextVNode(" address. If you make a payment from a different address, the payment will not be accepted. ")
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            style: {"width":"180px"},
            class: "p-button p-component secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('closeModal')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Button, {
            style: {"width":"180px"},
            class: "p-button p-component secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('confirm')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Continue")
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"])
  ]))
}